import { render } from "./collection-blocks.vue?vue&type=template&id=3d0957fe"
import script from "./collection-blocks.vue?vue&type=script&lang=js"
export * from "./collection-blocks.vue?vue&type=script&lang=js"

import "./collection-blocks.vue?vue&type=style&index=0&id=3d0957fe&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__